import { Outlet } from 'react-router-dom'
import { SiteHeader } from '@shared/SiteHeader'
import { SiteFooter } from '@shared/SiteFooter'
import { SiteFootnoteProvider } from '@shared/SiteFootnote'
import { BackgroundGlow } from '@shared/BackgroundGlow'

export function SiteLayout() {
  return (
    <SiteFootnoteProvider>
      <div className="relative min-h-screen overflow-x-hidden">
        <BackgroundGlow />
        <SiteHeader />
        <main>
          <Outlet />
        </main>
        <SiteFooter />
      </div>
    </SiteFootnoteProvider>
  )
}
